import React, { useEffect, useState } from "react";
import Header from "../common/header/Header";
import OperatingHours from "./operatinghours";
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";
import TagInput from "./input-tags";
import PrimaryButton from "../common/buttons/PrimaryButton";
import SecondaryButton from "../common/buttons/SecondaryButton";

import { Toast } from "../common/toast/toast";
import { BackButton } from "../common/back-button/back-button";
import { getCountryStateInformation } from "../../reducer/slices/country-state/get-country-info-slice";
import { useDispatch, useSelector } from "react-redux";
import { getTimezoneList } from "../../reducer/slices/timezone/get-timezone-slice";
import { IconTimer } from "../../assets/icons/icon-timer";

import { useNavigate } from "react-router";
import AddEditHeader from "../common/add-edit-header/AddEditHeader";
import { CloseIcon } from "../../assets/icons/close-icon-simple";

const AddClinic = ({
  setIsAddLocation,
  addToast,
  removeToast,
  setOpenClinicSidebar,
}) => {
  const [organizationName, setOrganizationName] = useState();
  const [addName, setAddName] = useState("");
  const [addPhoneNumber, setAddPhoneNumber] = useState("");
  const [addPrincipalInvestigator, setAddPrincipalInvestigator] = useState("");
  const [city, setCity] = useState("");
  const [postal, setPostal] = useState("");
  const [addAddress, setAddAddress] = useState("");
  const [addDisease, setAddDisease] = useState([]);
  const [selectedTimeZoneName, setSelectedTimeZoneName] = useState("");
  const [selectCountry, setSelectCountry] = useState("");
  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [stateList, setStateList] = useState();
  const [selectStateName, setSelectStateName] = useState("");
  const [selectedStateId, setSelectedStateId] = useState("");
  const [timezone, setTimezone] = useState("");
  const [tags, setTags] = useState([]);

  const dispatch = useDispatch();
  const countryData = useSelector((state) => state.country.countryData);
  const timezoneData = useSelector((state) => state.time_zone.data);
  const [isOpen, setIsOpen] = useState(false);
  const handleSelectTimeZoneChange = (e) => {
    const selectedName = e.target.value; // Get the selected timezone
    setSelectedTimeZoneName(selectedName);
    const selectedTimeZone = timezoneData.find(
      (tz) => tz.displayName === selectedName
    );
    setSelectedTimeZoneId(selectedTimeZone.timezoneID);
  };

  function getCountryAndStateId(data, stateName) {
    for (const country of data) {
      const state = country.stateResponseModel.find(
        (state) => state.stateName.toLowerCase() === stateName.toLowerCase()
      );
      if (state) {
        return {
          countryID: country.countryID,
          stateID: state.stateID,
        };
      }
    }
    return null; // Return null if no matching state is found
  }

  const handleSelectCountryChange = (e) => {
    const selectedName = e.target.value; // Get the selected timezone
    setSelectCountry(selectedName);
    setSelectStateName("");
    setSelectedStateId("");
    const selectedTimeZone = countryData.find(
      (tz) => tz.countryName === selectedName
    );

    setSelectedCountryId(selectedTimeZone.countryID);
    setStateList(selectedTimeZone.stateResponseModel);
  };

    const handleSelectStateChange = (e) => {
        const selectedName = e.target.value; // Get the selected timezone
        setSelectStateName(selectedName)
        const stateAndCountryId =  getCountryAndStateId(countryData,selectedName)
        setSelectedCountryId(stateAndCountryId.countryID)
        setSelectedStateId(stateAndCountryId.stateID)
    };


  const addOperatingHours = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    dispatch(getCountryStateInformation({}));
    dispatch(getTimezoneList({}));
  }, []);

  const [getTimezone, setGetTimezone] = useState();
  const fetchTimezone = async () => {
    const response = await axios.get(ENDPOINTS.CLINIC.TIMEZONE);
    setGetTimezone(response.data.data);
  };

  const [selectedTimeZoneId, setSelectedTimeZoneId] = useState("");

  const handleSelectChange = (e) => {
    const selectedName = e.target.value; // Get the selected timezone
    setTimezone(selectedName);
    const selectedTimeZone = getTimezone.find(
      (tz) => tz.displayName === selectedName
    );
    setSelectedTimeZoneId(selectedTimeZone.timezoneID);
  };

  useEffect(() => {
    fetchTimezone();
  }, [selectedTimeZoneId]);

  const closePopup = () => {
    setIsOpen(false);
    setPopup({ show: false, message: "", isError: false });
  };

  const [getDataOp, setgetDataOp] = useState([
    {
      day: "Sunday",
      isChecked: false,
      time: {
        from: null,
        to: null,
      },
    },
    {
      day: "Monday",
      isChecked: true,
      time: {
        from: "08:00:00",
        to: "17:00:00",
      },
    },
    {
      day: "Tuesday",
      isChecked: true,
      time: {
        from: "08:00:00",
        to: "17:00:00",
      },
    },
    {
      day: "Wednesday",
      isChecked: true,
      time: {
        from: "08:00:00",
        to: "17:00:00",
      },
    },
    {
      day: "Thursday",
      isChecked: true,
      time: {
        from: "08:00:00",
        to: "17:00:00",
      },
    },
    {
      day: "Friday",
      isChecked: true,
      time: {
        from: "08:00:00",
        to: "17:00:00",
      },
    },
    {
      day: "Saturday",
      isChecked: false,
      time: {
        from: null,
        to: null,
      },
    },
  ]);
  const [inputResponse, setInputResponse] = useState([]);

  const [popup, setPopup] = useState({
    show: false,
    message: "",
    isError: false,
  });

  // Validations..............

    const [formErrors, setFormErrors] = useState({
        name: '',
        phoneNumber: '',
        principalInvestigator: '',
        address: '',
        disease: '',
        operatingHours: '',
        organizationName: '',
    });

   
    const validateForm = () => {
        const errors = {};
    
        // Validate Location Name
        if (!addName.trim()) {
            errors.name = "Location Name is required.";
        }
    
        // Validate Phone Number
        const phoneNumberPattern = /^[0-9]{10}$/; // Assuming 10-digit phone number
        if (!addPhoneNumber.trim()) {
            errors.phoneNumber = "Phone Number is required.";
        } else if (!phoneNumberPattern.test(addPhoneNumber)) {
            errors.phoneNumber = "Please enter a valid 10-digit phone number.";
        }
    
        // Validate Principal Investigator
        if (!addPrincipalInvestigator.trim()) {
            errors.principalInvestigator = "Principal Investigator is required.";
        }
    
        // Validate Time Zone
        if (!selectedTimeZoneName) {
            errors.timezone = "Time Zone is required.";
        }
    
        // Validate Operating Hours
        if (!inputResponse.trim()) {
            errors.operatingHours = "Operating Hours are required.";
        }
    
        // Validate Address
        if (!addAddress.trim()) {
            errors.address = "Address is required.";
        }
    
        // Validate Country
        if (!selectCountry) {
            errors.country = "Country/Region is required.";
        }
    
        // Validate State
        if (!selectStateName) {
            errors.state = "State is required.";
        }
    
        // Validate City
        if (!city.trim()) {
            errors.city = "City is required.";
        }
    
        // Validate Zip Code
        const postalCodePattern = /^[0-9]{5,6}$/; // Adjust as needed for postal code format
        if (!postal.trim()) {
            errors.postal = "Zip Code is required.";
        } else if (!postalCodePattern.test(postal)) {
            errors.postal = "Please enter a valid Zip Code.";
        }
    
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const navigate = useNavigate();
    const goToLogin = () => {
        navigate("/login");
      };
    const handleAddClinic = async (e) => {
        e.preventDefault()

       const resBody = {
            "name": addName,
            "phoneNumber": addPhoneNumber,
            "principalInvestigator": addPrincipalInvestigator,
            "timezoneID": selectedTimeZoneId,
            "operatingHoursJson": getDataOp,
            "operatingHours": "",
            "address":addAddress,
            "locationID": null,
            "countryID": selectedCountryId,
            "stateID": selectedStateId,
            "city": city,
            "zip": postal
          }
        
        if (!validateForm()) {
            
            return; // If validation fails, stop form submission
        }
        try {
            const response = await axios.post(ENDPOINTS.CLINIC.ADD_CLINIC, resBody)
            addToast("Location has been added successfully.", "success")
            setAddName(' ')
            setAddPhoneNumber(' ')
            setAddPrincipalInvestigator(' ')
            setAddAddress(' ')
            setAddDisease([])
            setTimezone('')
            setInputResponse('')
            setTags([])
            setSelectStateName('')
            setSelectedCountryId('')
            setSelectedStateId('');
            setSelectCountry('')
            setOrganizationName('')
            setTimezone('')
            setSelectedTimeZoneName('')
            setSelectedTimeZoneId('')
            localStorage.removeItem('days')
            localStorage.removeItem('weekdays')
            localStorage.removeItem('weekend')
            localStorage.removeItem('time')
        setCity('')
        setStateList('')
           
        }
        catch (error) {
            addToast(error.message, "error")
        }
    }



  return (
    <>
       <div
        className="border-b border-[#B2ACC9] w-full header_sub"
        style={{ borderColor: "rgb(200, 214, 230)" }}
      >
        <div className="flex justify-between items-center w-full px-5 py-6">
          <h2 className="font-semibold text-left">Add Location</h2>
          <button onClick={() => setIsAddLocation(false)}>
            <CloseIcon />{" "}
          </button>
        </div>
      </div>

      <div className="main-body  p-8 h-[calc(100vh_-_320px)] w-[570px] overflow-auto scroll-m-0">
        <form onSubmit={handleAddClinic} className="w-full grid gap-4">
          <div>
            <label for="clinicName" class="block form_label_color pb-4">
              Location Name <span className="aestrick_color">*</span>
            </label>
            <input
              type="text"
              name="name"
              className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
              required
              // placeholder="Your First Name"
              value={addName}
              onChange={(e) => setAddName(e.target.value)}
            />
            {formErrors.name && (
              <span className="text-red-500">{formErrors.name}</span>
            )}
          </div>
          <div>
            <label for="phoneNumber" class="block form_label_color pb-4">
              Phone Number <span className="aestrick_color">*</span>
            </label>
            <input
              type="text"
              name="phoneNumber"
              className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
              required
              // placeholder="Please enter Phone number"
              value={addPhoneNumber}
              onChange={(e) => setAddPhoneNumber(e.target.value)}
            />
            {formErrors.phoneNumber && (
              <span className="text-red-500">{formErrors.phoneNumber}</span>
            )}
          </div>
          <div className="w-full relative">
            <label className="block form_label_color pb-4">
              Time Zone <span className="aestrick_color">*</span>
            </label>
            <select
              id="timezone"
              name="timezone"
              value={selectedTimeZoneName}
              className="border_color border text-sm rounded-lg block w-full p-2.5 h-12 appearance-none"
              onChange={handleSelectTimeZoneChange}
            >
              <option value={""} selected disabled>
                Select Timezone
              </option>
              {timezoneData?.map((tz) => (
                <option key={tz.timezoneID} value={tz.displayName}>
                  {tz.displayName}
                </option>
              ))}
            </select>
            <span className="absolute right-[20px] top-[65px] transform -translate-y-1/2 pointer-events-none">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                  stroke="#245CEA"
                  strokeWidth="2"
                  stroke-miterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </div>
          <div>
            <label
              for="principalInvestigator"
              class="block form_label_color pb-4"
            >
              Principal Investigator <span className="aestrick_color">*</span>
            </label>
            <input
              type="text"
              name="principalInvestigator"
              className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
              required
              // placeholder="Principal Investigator"
              value={addPrincipalInvestigator}
              onChange={(e) => setAddPrincipalInvestigator(e.target.value)}
            />
            {formErrors.principalInvestigator && (
              <span className="text-red-500">
                {formErrors.principalInvestigator}
              </span>
            )}
          </div>
          <div>
            <label for="operatingHours" class="block form_label_color pb-4">
              Operating Hours <span className="aestrick_color">*</span>
            </label>
            <div className="flex relative">
              <input
                type="text"
                name="operatinghours"
                className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                required
                // placeholder="Add operating hours"
                value={inputResponse && inputResponse}
                onClick={addOperatingHours}
              />
              <span
                onClick={addOperatingHours}
                className="absolute right-[20px] top-3"
              >
                <IconTimer />
              </span>
            </div>
            {formErrors.operatingHours && (
              <span className="text-red-500">{formErrors.operatingHours}</span>
            )}
          </div>
          <div className="w-full">
            <label for="address" class="block form_label_color pb-4">
              Address <span className="aestrick_color">*</span>
            </label>
            <input
              type="text"
              name="address"
              className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
              required
              // placeholder="Please enter Address"
              value={addAddress}
              onChange={(e) => setAddAddress(e.target.value)}
            />
            {formErrors.address && (
              <span className="text-red-500">{formErrors.address}</span>
            )}
          </div>
          <div className="w-full relative">
            <label className="block form_label_color pb-4">
              Country/Region <span className="aestrick_color">*</span>
            </label>
            <select
              id="countyr"
              name="country"
              value={selectCountry}
              className="border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
              onChange={handleSelectCountryChange}
            >
              <option value={""} selected disabled>
                Select Country
              </option>
              {countryData?.map((tz) => (
                <option key={tz.countryID} value={tz.countryName}>
                  {tz.countryName}
                </option>
              ))}
            </select>
            <span className="absolute right-[20px] top-[65px] transform -translate-y-1/2 pointer-events-none">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                  stroke="#245CEA"
                  strokeWidth="2"
                  stroke-miterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </div>
          <div className="w-full relative">
            <label className="block form_label_color pb-4">
              State <span className="aestrick_color">*</span>
            </label>
            <select
              id="state"
              name="state"
              value={selectStateName}
              className="border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
              onChange={handleSelectStateChange}
            >
              <option value={""} selected disabled></option>
              {stateList &&
                stateList.length &&
                stateList.map((tz) => (
                  <option key={tz.stateID} value={tz.stateName}>
                    {tz.stateName}
                  </option>
                ))}
            </select>
            <span className="absolute right-[20px] top-[65px] transform -translate-y-1/2 pointer-events-none">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                  stroke="#245CEA"
                  strokeWidth="2"
                  stroke-miterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </div>
          <div>
            <label
              for="principalInvestigator"
              class="block form_label_color pb-4"
            >
              City <span className="aestrick_color">*</span>
            </label>
            <input
              type="text"
              name="principalInvestigator"
              className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
              required
              // placeholder="Please enter city"
              value={city}
              onChange={(e) => setCity(e.target.value)}
            />
            {formErrors.city && (
              <span className="text-red-500">{formErrors.city}</span>
            )}
          </div>
          <div>
            <label for="organization_name" class="block form_label_color pb-4">
              Zip Code <span className="aestrick_color">*</span>
            </label>
            <input
              type="text"
              name="organization_name"
              className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
              required
              // placeholder="Please enter Postal Code"
              value={postal}
              onChange={(e) => setPostal(e.target.value)}
            />
            {formErrors.postal && (
              <span className="text-red-500">{formErrors.postal}</span>
            )}
          </div>
          <div className="fixed shadow-[0_-4px_20px_0_rgba(0,0,0,0.25)] p-5 pl-[36px] bottom-0 w-full -ml-8 bg-white pl-8 flex gap-[20px]">
            <button type="submit" className="btn-primary-base-bar primary_btn">
              Add
            </button>
            <BackButton onClick={() => setIsAddLocation(false)} />
          </div>
        </form>
      </div>

      {/* popup for operating hours */}
      {isOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-2 relative">
            <button
              onClick={closePopup}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
            <OperatingHours
              getDataOp={getDataOp}
              setgetDataOp={setgetDataOp}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              setInputResponse={setInputResponse}
              inputResponse={inputResponse}
            />
          </div>
        </div>
      )}

      {/* Popup on submission */}
      {popup.show && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-6 relative">
            <div className={`popup ${popup.isError ? "error" : "success"}`}>
              <p>{popup.message}</p>
              <button
                onClick={closePopup}
                className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddClinic;
